import React, { useEffect, useState } from "react";
import { ConfigProvider, Select, Spin } from "antd";
import { IoMdArrowDropdown } from "react-icons/io";
import { useDispatch } from "react-redux";
import {
  GetContactById,
  GetContactsData,
  SubmitContactData,
} from "../../../Api/SuperAdminVault/Contacts";
import dayjs from "dayjs";
import ContactOtpModal from "./ContactOtpModal";

const categoryOptions = [
  { value: "Partners", label: "Partners" },
  { value: "Vendors", label: "Vendors" },
  { value: "Auditors", label: "Auditors" },
  { value: "Finance", label: "Finance" },
  { value: "Escalation Matrix", label: "Escalation Matrix" },
];

const priorityOptions = [
  { value: "P1", label: "P1" },
  { value: "P2", label: "P2" },
  { value: "P3", label: "P3" },
  { value: "P4", label: "P4" },
];

const ContactForm = ({
  contactId,
  mode,
  setModalIsOpen,
  onSuccess,
  currentFilter,
}) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
     const [otpModalOpen, setOtpModalOpen] = useState(false);
       const [otpContact, setOtpContact] = useState(null);
  const [values, setValues] = useState({
    contact_name: "",
    designation: "",
    organisation: "",
    category: "",
    priority: "",
    email: "",
    phone: "",
    notes: "",
    is_sensitive:false,
  });

  const [errors, setErrors] = useState({});
  const fetchContact = async () => {
    setFetchLoading(true);

    try {
      const data = await GetContactById(contactId);

      if (data) {
        setValues({
          contact_name: data.contact_name || "",
          designation: data.designation || "",
          organisation: data.organisation || "",
          category: data.category || "",
          priority: data.priority || "",
          email: data.email || "",
          phone: data.phone || "",
          notes: data.notes || "",
   is_sensitive: Boolean(data.is_sensitive),
        });
      }
    } finally {
      setFetchLoading(false);
    }
  };
  useEffect(() => {
    if (mode === "edit" && contactId) {
      fetchContact();
    }
  }, [mode, contactId]);



  const validate = () => {
    const newErrors = {};

    if (!values.contact_name.trim()) {
      newErrors.contact_name = "Contact Name is required";
    } else if (values.contact_name.trim().length < 3) {
      newErrors.contact_name = "Min 3 characters required";
    }

    if (!values.designation.trim()) {
      newErrors.designation = "Designation is required";
    }

    if (!values.organisation.trim()) {
      newErrors.organisation = "Organisation is required";
    }

    if (!values.category) {
      newErrors.category = "Category is required";
    }

    if (!values.priority) {
      newErrors.priority = "Priority is required";
    }

    if (!values.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!values.phone.trim()) {
      newErrors.phone = "Phone is required";
    } else if (!/^[6-9]\d{9}$/.test(values.phone)) {
      newErrors.phone = "Enter valid 10 digit mobile number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const cleanText = (value) =>
    value
      .replace(/^\s+/, "")
      .replace(/\s{2,}/g, " ")
      .replace(/[^A-Za-z0-9\s._@&()/,-]/g, "");

  const handleChange = (name, value) => {
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

 const handleFormSuccess = () => {
  GetContactsData({
    dispatch,
    page: 1,
    limit: 10,
    filter_category: currentFilter || "",
  });

  onSuccess && onSuccess();
  setModalIsOpen(false);
};

const handleSubmit = async () => {
  if (!validate()) return;

  setLoading(true);

  try {
    const result = await SubmitContactData(
      values,
      mode === "edit" ? contactId : null
    );

    if (!result) return;

    const isOtpSent =
      result?.message?.toLowerCase() === "otp send successfully" ||
      result?.message?.toLowerCase()?.includes("otp");

    if (mode === "edit" && isOtpSent) {
      setOtpModalOpen(true);
      return;
    }

    handleFormSuccess();
  } finally {
    setLoading(false);
  }
};

  if (fetchLoading) {
    return (
      <div className="absolute inset-0 flex justify-center items-center z-10">
        <Spin size="large" />
      </div>
    );
  }
const labelClass =
  "text-[#1F4B7F] text-[0.95vw] font-semibold leading-[1.9vw] mt-0.2";

const requiredClass =
  "text-red-500 text-[0.85vw] pl-[0.15vw]";

const fieldWrapperClass =
  "relative col-span-1 flex flex-col min-w-0 mt-1";

const inputClass =
  "box-border border-r-[0.18vw] mt-[0.12vw] border-l-[0.08vw] border-t-[0.08vw] border-b-[0.18vw] border-[#1F487C] text-[#1F487C] text-[0.78vw] h-[2.3vw] w-full rounded-[0.3vw] outline-none px-[0.55vw] placeholder:text-[0.95vw] placeholder:font-sans";

const selectClass =
  "umselect custom-select bg-white outline-none w-full mt-[0.12vw] h-[2.3vw] text-[0.75vw] border-[#1F4B7F] border-l-[0.08vw] border-t-[0.08vw] rounded-[0.3vw] border-r-[0.18vw] border-b-[0.18vw] placeholder:text-[0.80vw]";

const errorClass =
  "text-red-500 text-[0.80vw] absolute left-0 bottom-[-1.2vw]";

const selectOptionClass =
  "text-[0.82vw] px-[0.15vw] py-[0.05vw] font-normal";

const dropdownStyle = {
  maxHeight: "15vw",
  overflowY: "auto",
  zIndex: 9999,
};
  return (
<>
<div className="h-full px-[0.55vw] relative overflow-visible">
  <div className="flex justify-between items-center mr-[0.1vw] h-[1.9vw]">
    <div className="text-[1.5vw] text-[#1F4B7F] font-semibold">
      {mode === "edit" ? "UPDATE CONTACT" : "ADD CONTACT"}
    </div>

    <div className="flex gap-x-[1vw]">
      <button
        type="button"
        className="flex text-white text-[1vw] bg-[#1F4B7F] px-[0.75vw] gap-[0.35vw] py-[0.25vw] rounded-[0.4vw] items-center justify-center"
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? "Saving..." : mode === "edit" ? "Update" : "Save"}
      </button>
    </div>
  </div>

  {loading && (
    <div className="absolute inset-0 flex justify-center items-center z-10">
      <Spin size="large" />
    </div>
  )}

  <div className="umselect grid grid-cols-2 gap-x-[1.5vw] gap-y-[0.78vw] pt-[0.45vw]">
    <div className={fieldWrapperClass}>
      <label className={labelClass}>
        Contact Name
        <span className={requiredClass}>*</span>
      </label>

      <input
        type="text"
        name="contact_name"
        placeholder="Enter Contact Name"
        autoComplete="off"
        value={values.contact_name}
        onChange={(e) =>
          handleChange("contact_name", cleanText(e.target.value))
        }
        className={inputClass}/>

      {errors.contact_name && (
        <p className={errorClass}>
          {errors.contact_name}
        </p>
      )}
    </div>

    <div className={fieldWrapperClass}>
      <label className={labelClass}>
        Designation
        <span className={requiredClass}>*</span>
      </label>

      <input
        type="text"
        name="designation"
        placeholder="Enter Designation"
        autoComplete="off"
        value={values.designation}
        onChange={(e) =>
          handleChange("designation", cleanText(e.target.value))
        }
        className={inputClass}  />

      {errors.designation && (
        <p className={errorClass}>
          {errors.designation}
        </p>
      )}
    </div>

    <div className={fieldWrapperClass}>
      <label className={labelClass}>
        Organisation
        <span className={requiredClass}>*</span>
      </label>

      <input
        type="text"
        name="organisation"
        placeholder="Enter Organisation"
        autoComplete="off"
        value={values.organisation}
        onChange={(e) =>
          handleChange("organisation", cleanText(e.target.value))
        }
        className={inputClass}  />

      {errors.organisation && (
        <p className={errorClass}>
          {errors.organisation}
        </p>
      )}
    </div>

    <div className={fieldWrapperClass}>
      <label className={labelClass}>
        Category
        <span className={requiredClass}>*</span>
      </label>

      <ConfigProvider
        theme={{
          components: {
            Select: {
              optionActiveBg: "#aebed1",
              optionSelectedColor: "#FFF",
              optionSelectedBg: "#e5e5e5",
              optionHeight: "1.8vw",
            },
          },
        }}
      >
        <Select
          showSearch
          value={values.category || undefined}
          placeholder="Select Category"
  className={selectClass} 
  optionFilterProp="search"
          onChange={(value) => handleChange("category", value)}
          listHeight={120}
getPopupContainer={() => document.body}
dropdownStyle={dropdownStyle}
          suffixIcon={
            <span style={{ fontSize: "0.9vw", color: "#1f487c" }}>
              <IoMdArrowDropdown size="1.55vw" />
            </span>
          }
          style={{ padding: 2 }}
          options={[
            {
              value: "",
              label: <div >Select Category</div>,
              search: "Select Category",
              disabled: true,
            },
            ...categoryOptions.map((item) => ({
              value: item.value,
              search: item.label,
              label: (
                <div className={selectOptionClass}>
                  {item.label}
                </div>
              ),
            })),
          ]}
        />
      </ConfigProvider>

      {errors.category && (
        <p className={errorClass}>
          {errors.category}
        </p>
      )}
    </div>

    <div className={fieldWrapperClass}>
      <label className={labelClass}>
        Priority
        <span className={requiredClass}>*</span>
      </label>

      <ConfigProvider
        theme={{
          components: {
            Select: {
              optionActiveBg: "#aebed1",
              optionSelectedColor: "#FFF",
              optionSelectedBg: "#e5e5e5",
              optionHeight: "1.8vw",
            },
          },
        }}
      >
        <Select
          showSearch
          value={values.priority || undefined}
           className={selectClass} 
            placeholder="Select Priority"
          optionFilterProp="search"
          onChange={(value) => handleChange("priority", value)}
          listHeight={180}
getPopupContainer={() => document.body}
dropdownStyle={dropdownStyle}
          suffixIcon={
            <span style={{ fontSize: "0.9vw", color: "#1f487c" }}>
              <IoMdArrowDropdown size="1.55vw" />
            </span>
          }
          style={{ padding: 2 }}
          options={[
            {
              value: "",
              label: <div>Select Priority</div>,
              search: "Select Priority",
              disabled: true,
            },
            ...priorityOptions.map((item) => ({
              value: item.value,
              search: item.label,
              label: (
                <div className={selectOptionClass}>
                  {item.label}
                </div>
              ),
            })),
          ]}
        />
      </ConfigProvider>

      {errors.priority && (
        <p className={errorClass}>
          {errors.priority}
        </p>
      )}
    </div>

    <div className={fieldWrapperClass}>
      <label className={labelClass}>
        Email
        <span className={requiredClass}>*</span>
      </label>

      <input
        type="text"
        name="email"
        placeholder="Enter Email"
        autoComplete="off"
        value={values.email}
        onChange={(e) =>
          handleChange("email", e.target.value.replace(/\s/g, "").toLowerCase())
        }
        className={inputClass}  />

      {errors.email && (
        <p className={errorClass}>
          {errors.email}
        </p>
      )}
    </div>

    <div className={fieldWrapperClass}>
      <label className={labelClass}>
        Phone
        <span className={requiredClass}>*</span>
      </label>

      <input
        type="text"
        name="phone"
        placeholder="Enter Phone"
        autoComplete="off"
        maxLength={10}
        value={values.phone}
        onChange={(e) =>
          handleChange("phone", e.target.value.replace(/\D/g, ""))
        }
        className={inputClass}   />

      {errors.phone && (
        <p className={errorClass}>
          {errors.phone}
        </p>
      )}
    </div>

    <div className={fieldWrapperClass}>
      <label className={labelClass}>
        Sensitive
      </label>

      <ConfigProvider
        theme={{
          components: {
            Select: {
              optionActiveBg: "#aebed1",
              optionSelectedColor: "#1F487C",
              optionSelectedBg: "#e5e5e5",
              optionHeight: "1.8vw",
            },
          },
        }}
      >
        <Select
          value={values.is_sensitive ? "true" : "false"}
          className={selectClass}
            onChange={(value) => handleChange("is_sensitive", value === "true")}
         getPopupContainer={() => document.body}
dropdownStyle={dropdownStyle}
          suffixIcon={
            <span style={{ fontSize: "0.9vw", color: "#1f487c" }}>
              <IoMdArrowDropdown size="1.55vw" />
            </span>
          }
          style={{ padding: 2 }}
          options={[
            {
              value: "false",
              label: (
                <div className={selectOptionClass}>
                  No
                </div>
              ),
              search: "No",
            },
            {
              value: "true",
              label: (
                <div className={selectOptionClass}>
                  Yes
                </div>
              ),
              search: "Yes",
            },
          ]}
        />
      </ConfigProvider>
    </div>

    <div className="relative col-span-2 flex flex-col min-w-0">
      <label className={labelClass}>
        Notes
      </label>

      <textarea
        value={values.notes}
        onChange={(e) => handleChange("notes", cleanText(e.target.value))}
        placeholder="Enter Notes"
        rows="3"
        className="box-border border-r-[0.18vw] mt-[0.12vw] border-l-[0.08vw] border-t-[0.08vw] border-b-[0.18vw] border-[#1F487C] text-[#1F487C] text-[0.88vw] w-full h-[4.5vw] rounded-[0.3vw] outline-none px-[0.55vw] py-[0.35vw] placeholder:text-[0.95vw] placeholder:font-sans resize-none"   />
    </div>
  </div>
  
</div>
<ContactOtpModal
  show={otpModalOpen}
  onClose={() => {
    setOtpModalOpen(false);
    setOtpContact(null);
  }}
  onVerified={() => {
    setOtpModalOpen(false);
    handleFormSuccess();
  }}
  contactId={contactId}
  payload={values}
  actionType="update_contact"
/>
</>
  );
};

export default ContactForm;